import React from "react";
import { Trans } from "react-i18next";
import Wone_Logo from "Assets/wone_logo.svg";
import { LearnerMembership } from "apps/user/learner/api/types";
import styles from "./styles.module.scss";
import { ReactComponent as CheckMark } from "Assets/icon/check-mark.svg";
import { Button } from "components/ui";
import { useTranslation } from "lib/i18n/use-translation";
interface SettingsMembershipProps {
  membership: LearnerMembership;
}
const SettingsMembership = ({ membership }: SettingsMembershipProps) => {
  const { t } = useTranslation(["settings"]);
  const isIndividualAccount =
    membership?.type?.toLowerCase() === "individual account";

  return (
    <div className={styles["settings-membership"]}>
      <h1>{membership?.title}</h1>
      <img
        src={Wone_Logo}
        className={styles["membership-logo"]}
        alt="walk-on-earth-logo"
        width="82px"
        height="20px"
      />
      <h2>{membership?.type}</h2>
      <h3>{membership.advantages.heading}</h3>
      {membership?.advantages?.items.map((item, index) => (
        <div key={index} className={styles["membership-items"]}>
          <div className={styles["membership-thumb"]}>
            <CheckMark className={styles["membership-check-icon"]} />
          </div>

          <div className={styles["membership-name-desc"]}>
            <h6>{item.name}</h6>
            <p>{item.description}</p>
          </div>
        </div>
      ))}

      {isIndividualAccount && (
        <div className={styles["subscription-management"]}>
          <h4>{t("settings:membership.manageSubscriptionTitle")}</h4>
          <p className={styles["subscription-description"]}>
            {t("settings:membership.manageSubscriptionBody")}
          </p>
          <Button
            variant="enclosed-primary"
            onClick={() =>
              window.open(
                "https://billing.stripe.com/p/login/5kQ8wRfMK5zPfwic6d0RG00",
                "_blank",
                "noopener,noreferrer"
              )
            }
            className={styles["subscription-button"]}
          >
            {t("settings:membership.manageSubscription")}
          </Button>
          <div className={styles["cancellation-policy"]}>
            <p>
              <Trans
                i18nKey="settings:membership.cancellationPolicy"
                components={{ strong: <strong /> }}
              />
            </p>
            <p>{t("settings:membership.noChargeBody")}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SettingsMembership;
